const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const getToken = () => {
  try {
    return JSON.parse(sessionStorage.getItem("authUser") || "{}")?.token || null;
  } catch { return null; }
};

/**
 * Send an activity event to the backend (fire-and-forget).
 * @param {"PAGE_VISIT"|"REPORT_DOWNLOAD"|"SETTINGS_CHANGED"} eventType
 * @param {object} details  - extra info stored as JSONB
 */
export const trackActivity = (eventType, details = {}) => {
  const token = getToken();
  if (!token) return;

  fetch(`${API_BASE_URL}/auth/track`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ event_type: eventType, details }),
  }).catch(() => {}); // silent fail — never block the UI
};

/**
 * Convenience wrappers
 */
export const trackPageVisit   = (pageName, path) => trackActivity("PAGE_VISIT",      { page: pageName, path });
export const trackDownload    = (reportName, details = {}) => trackActivity("REPORT_DOWNLOAD", { report: reportName, ...details });
export const trackSettingsChange = (section, changes = {}) => trackActivity("SETTINGS_CHANGED", { section, ...changes });
